export { IAttachedFile } from './IAttachedFile';
